import { render, staticRenderFns } from "./yhassess.vue?vue&type=template&id=628f62a8&scoped=true&"
import script from "./yhassess.vue?vue&type=script&lang=js&"
export * from "./yhassess.vue?vue&type=script&lang=js&"
import style0 from "./yhassess.vue?vue&type=style&index=0&id=628f62a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f62a8",
  null
  
)

export default component.exports